import APIService from '../../services/api'

import { getMapDataFromExhibitor } from './resultmap.helper'

import {
  SEARCH_EXHIBITOR_LIST,
  SEARCH_EXHIBITOR_MAP,
  SEARCH_EXHIBITOR_PERIOD,
  FETCH_RESULT_LIST,
  FETCH_RESULT_MAP,
  FETCH_RESULT_PERIOD,
  UPDATE_RESULT_LIST,
  UPDATE_RESULT_MAP,
  UPDATE_RESULT_PERIOD,
  ERROR_API,
  ITEMS_PER_PAGE_FOR_MAP_DISPLAY
} from './constants'

import { EXHIBITOR, getFiltersComputed } from '../../services/filters'

export const actionsExhibitor = {
  [SEARCH_EXHIBITOR_LIST] ({commit, state},
    { value, order, direction, page, itemsPerPage, begin, end, jsonFilters }) {
    commit(FETCH_RESULT_LIST)
    let filters = getFiltersComputed(
      EXHIBITOR,
      [],
      { value, order, direction, page, itemsPerPage, begin, end, jsonFilters }
    )
    APIService.searchExhibitor({
      transform: true,
      filters,
      satisfy: 'all',
      order: {
        column: order || 'begin_date',
        direction: direction || 'ASC'
      },
      page: {
        number: page,
        itemsPerPage
      }
    }).then(json => {
      commit(UPDATE_RESULT_LIST, {
        results: json.visu_exhibitor || [],
        total: json._results || 0
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [SEARCH_EXHIBITOR_MAP] ({commit, state},
    { value, begin, end, jsonFilters }) {
    commit(FETCH_RESULT_MAP)
    let filters = getFiltersComputed(
      EXHIBITOR,
      [{
        property: 'section_x',
        matchType: 'nis',
        value: null
      }],
      { value, begin, end, jsonFilters }
    )

    APIService.searchExhibitor({
      transform: true,
      filters,
      satisfy: 'all',
      order: {
        column: 'begin_date',
        direction: 'DESC'
      },
      page: {
        number: 1,
        itemsPerPage: ITEMS_PER_PAGE_FOR_MAP_DISPLAY
      }
    }).then(json => {
      const results = getMapDataFromExhibitor(json.visu_exhibitor)
      commit(UPDATE_RESULT_MAP, {
        results: results,
        total: json._results || 0
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [SEARCH_EXHIBITOR_PERIOD] ({commit, state},
    { value, jsonFilters }) {
    commit(FETCH_RESULT_PERIOD)
    let filters = getFiltersComputed(
      EXHIBITOR,
      [],
      { value, jsonFilters }
    )

    APIService.searchExhibitor({
      filters,
      transform: true,
      satisfy: 'all',
      order: {
        column: 'begin_date',
        direction: 'ASC'
      },
      page: {
        number: 1,
        itemsPerPage: 1
      },
      columns: 'begin_date'
    }).then(jsonBegin => {
      APIService.searchExhibitor({
        filters,
        transform: true,
        satisfy: 'all',
        order: {
          column: 'begin_date',
          direction: 'DESC'
        },
        page: {
          number: 1,
          itemsPerPage: 1
        },
        columns: 'begin_date'
      }).then(jsonEnd => {
        commit(UPDATE_RESULT_PERIOD, {
          period: {
            begin: jsonBegin.visu_exhibitor[0].begin_date,
            end: jsonEnd.visu_exhibitor[0].begin_date
          }
        })
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  }
}

export default actionsExhibitor



// WEBPACK FOOTER //
// ./src/store/search/actions.exhibitor.js